import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Game} from "../Game";
import {gsap} from "gsap";
import {NormalResultPresentation} from "./NormalResultPresentation";
import {IMonster} from "../server/IData";

export class AvalancheFillUpPresentation extends NormalResultPresentation {

    public start(flowStateController: FlowStateController): void {
        const monsters: IMonster[] = Game.model.gameData.monsters;
        let monstersCount: number = 0;

        // 337
        monsters.forEach((monster: IMonster) => {
            if (monster.path) {
                monstersCount++;
            }
        });
        Game.visibleMonstersCount = monstersCount;

        flowStateController.setSkipCallback(() => this.skip());

        this._tl = gsap.timeline({
            onComplete: () => {
                this.completePresentation(flowStateController);
            }
        });

        // #230
        Game.monsterReelsView.toggleMask(true);

        let fillUpCtr: number = 0;
        for (let i: number = 0; i < Game.ACTIVE_REELS_NUM; i++) {
            const symbols: string[] = Game.model.gameData.reels[i],
                fillUpAnimation: gsap.core.Timeline = gsap.timeline();

            fillUpAnimation.add(this.preventSkipOnLastReel(i, flowStateController));
            if (Game.reelsView.reelModels[i].numSymbolsRemovedForAvalanche > 0) {
                fillUpAnimation.add(Game.reelsView.reelModels[i].fillUp(symbols));
            }

            this._tl.add(fillUpAnimation, (0.1 * fillUpCtr++));
        }
    }
}